import { asyncRequest, registerComponent } from "helpers";

registerComponent(
  "quick-view",
  class QuickView extends HTMLElement {
    constructor() {
      super();

      this.modal = this.closest("dialog");
      this.url = this.dataset.url;
      this.placeholder = this.querySelector("[data-quick-view-placeholder]");

      this.modal.addEventListener("modalOpen", this.handleModalOpen.bind(this));
    }

    async handleModalOpen(event) {
      const response = await asyncRequest(this.url);

      if (response) {
        this.inject(response);
      } else {
        window.location.href = this.url;
      }
    }

    inject(html) {
      // Stop all videos when quick view content is updated (variant change)
      this.stopAllVideos();
      
      const newDOM = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".product-details");

      this.innerHTML = newDOM.outerHTML;

      if (typeof window.__bbVariantStockFilterSync === "function") {
        window.__bbVariantStockFilterSync();
      }
      
      // Add event listeners for thumbnail clicks within the quick view modal
      // Use a small delay to ensure DOM is fully updated
      setTimeout(() => {
        this.addThumbnailClickListeners();
      }, 100);
    }

    // Add event listeners for thumbnail clicks within the quick view modal
    addThumbnailClickListeners() {
      // Find all thumbnails and add direct click listeners
      const thumbnails = this.querySelectorAll('.product-media__secondary-item');
      
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (event) => {
          event.stopPropagation();
          
          // Stop all videos immediately using direct DOM queries
          const videoPlayers = document.querySelectorAll('video-player');
          
          videoPlayers.forEach((player, i) => {
            if (player.iframe) {
              player.stopVideo();
            }
          });
          
          // Also try the global function
          if (typeof window.stopAllVideos === 'function') {
            window.stopAllVideos();
          }
          
          // Also try direct iframe removal
          const iframes = document.querySelectorAll('video-player iframe');
          iframes.forEach((iframe, i) => {
            iframe.remove();
          });
          
          // Remove playing class
          const playingVideos = document.querySelectorAll('video-player.video-player--playing');
          playingVideos.forEach(video => {
            video.classList.remove('video-player--playing');
          });
        });
      });
    }

    // Method to stop all video players when quick view content is updated
    stopAllVideos() {
      // Use the global stopAllVideos function
      if (typeof window.stopAllVideos === 'function') {
        window.stopAllVideos();
      } else {
        // Fallback: Find all video player instances and stop them
        const videoPlayers = document.querySelectorAll('video-player');
        videoPlayers.forEach(player => {
          if (player.iframe) {
            player.stopVideo();
          }
        });
        
        // Also try to stop videos by removing iframes directly
        const iframes = document.querySelectorAll('video-player iframe');
        iframes.forEach(iframe => {
          iframe.remove();
        });
        
        // Remove video-player--playing class from all video players
        const playingVideos = document.querySelectorAll('video-player.video-player--playing');
        playingVideos.forEach(video => {
          video.classList.remove('video-player--playing');
        });
      }
    }
  }
);
